module.exports = __webpack_public_path__ + "img/IATA北京2026_01.12576750.png";